import React, { useMemo } from 'react';

import { LayoutCoordinateVisuals } from '../library/layout-geometry/LayoutCoordinateVisuals';
import { getActiveSnappingGuideLines } from '../store/selectors/snappingGuideLineSelectors';
import { useInvalidateEveryRender } from '../three/hooks/invalidation-hooks';
import { ManySegment, Segments } from '../three/layout/Segments';
import { useAppSelector } from './hooks';

const ELEVATION = -(1 / 17);

export function UploadedSnappingSegmentsController() {
  useInvalidateEveryRender();

  const segments = useAppSelector(getActiveSnappingGuideLines);
  const segmentsProps = useMemo(
    () =>
      segments.map((segment) => ({
        start: segment.basePoint.to3D(ELEVATION).toArray(),
        end: segment.endPoint.to3D(ELEVATION).toArray(),
      })),
    [segments],
  );

  if (segments.length === 0) return null;

  return (
    <LayoutCoordinateVisuals>
      <Segments initialSize={segments.length} sizeIncrement={100} color={0xffffff} transparent opacity={0.2}>
        <ManySegment segments={segmentsProps} />
      </Segments>
    </LayoutCoordinateVisuals>
  );
}
